import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FileUploadContext from './FileUploadContext';

import { DialogueHandler, FileUploadDialogueHandlers } from './types';

const { ConfirmationDialogue } = vp;

type FileUploadDialogueProps = {
  handleDialogue: DialogueHandler<FileUploadDialogueHandlers>;
};

type FC = FunctionComponent<FileUploadDialogueProps>;

const TicketCreationDialogue: FC = ({ handleDialogue }: FileUploadDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Contacts.FileUpload.Dialogue' });
  const { showInvalidFileAlert, showInvalidSizeAlert, showFileUploadAlert, fileUploadError } =
    useContext(FileUploadContext);
  return useMemo(
    () => (
      <div>
        {/* Delete User Error */}

        <ConfirmationDialogue
          isVisible={showFileUploadAlert}
          title={t('errorTitle', { defaultValue: 'Error! The file was not successful uploaded.' })}
          status="error"
          subTitle={`${fileUploadError}`}
          confirm={{
            label: t('backToFileUpload', { defaultValue: 'Back to File Upload' }),
            action: () => handleDialogue({ type: 'upload', state: 'fail' }),
          }}
        />
        {/* invalid File */}

        <ConfirmationDialogue
          isVisible={showInvalidFileAlert}
          title={t('errorTitle', { defaultValue: 'Error! The file was not successful uploaded.' })}
          status="error"
          subTitle={t('invalidFileFormat', { defaultValue: 'Invalid file format' })}
          confirm={{
            label: t('backToFileUpload', { defaultValue: 'Back to File Upload' }),
            action: () => handleDialogue({ type: 'upload', state: 'invalid' }),
          }}
        />
        {/* Invalid File Size */}

        <ConfirmationDialogue
          isVisible={showInvalidSizeAlert}
          title={t('errorTitle', { defaultValue: 'Error! The file was not successful uploaded.' })}
          status="error"
          subTitle={t('noTransactions', { defaultValue: 'The file contains no transaction' })}
          confirm={{
            label: t('backToFileUpload', { defaultValue: 'Back to File Upload' }),
            action: () => handleDialogue({ type: 'upload', state: 'size' }),
          }}
        />
      </div>
    ),
    [showInvalidFileAlert, showInvalidSizeAlert, showFileUploadAlert],
  );
};

export default TicketCreationDialogue;
